import { render, staticRenderFns } from "./password-lost.vue?vue&type=template&id=6056fa6d&scoped=true&"
import script from "./password-lost.vue?vue&type=script&lang=js&"
export * from "./password-lost.vue?vue&type=script&lang=js&"
import style0 from "./password-lost.vue?vue&type=style&index=0&id=6056fa6d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6056fa6d",
  null
  
)

export default component.exports